<template>
  <div id="profile">
    <div
      class="uk-section uk-section-secondary uk-light uk-margin uk-margin-remove"
    >
      <div class="uk-container">
        <div class="uk-grid-collapse" uk-grid>
          <div class="uk-width-1-6@m">
            <img alt="Humanoid logo" src="../assets/humanoid.svg" uk-svg />
          </div>
          <div
            class="uk-margin-medium-top uk-margin-medium-left uk-text-left uk-width-expand@m"
          >
            <h1>Ronit Kumar</h1>
            <div>
              <h3>
                You may say that I'm a dreamer. But I'm not the only one..
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="uk-container uk-container-expand uk-margin uk-margin-small uk-padding uk-padding-large"
    >
      <div
        class="uk-child-width-1-2@m uk-grid-small uk-grid-match"
        uk-grid
        uk-scrollspy="cls: uk-animation-fade; target: .uk-card; delay: 100; repeat: true"
      >
        <div v-for="card in cards" v-bind:key="card.id">
          <ProfileCards
            :items="card.items"
            :label="card.label"
            :msg="card.msg"
            :name="card.name"
            :link="card.link"
          ></ProfileCards>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileCards from "./ProfileCards.vue";

export default {
  name: "ProfileSection",
  components: { ProfileCards },
  data() {
    return {
      cards: [
        {
          id: 1,
          name: "Ronit Kumar",
          label: "PROFILE",
          msg: "Homo Sapien",
          link: "https://ronitrex.github.io/",
          items: [
            {
              id: 1,
              topic: "Education",
              points:
                "Master of Science in Computer Science, California State University, Long Beach",
            },
            {
              id: 2,
              topic: "Interests",
              points: "Graphic Design, Football, Skateboarding",
            },
            {
              id: 3,
              topic: "Multimedia and Design",
              points: "DaVinci Resolve, Adobe Photoshop CC, Kdenlive, GIMP",
            },
            {
              id: 4,
              topic: "Certifications",
              points:
                '<a href="https://www.hackerrank.com/ronitrex" target="_blank">HackerRank</a><br/><a href="https://www.datacamp.com/statement-of-accomplishment/track/fb7a911d4907c6c640698c7d5448ca8dc15c804a" target="_blank">Data Scientist with Python</a>',
            },
            {
              id: 5,
              topic: "Design Portfolio",
              points:
                '<a href="https://www.deviantart.com/ronitk/gallery" target="_blank">DeviantArt</a>',
            },
          ],
        },
        {
          id: 2,
          name: "github.com/ronitrex",
          label: "SKILLS",
          msg:
            'git commit -m "If you optimize everything, you will always be unhappy."',
          link: "https://github.com/ronitrex",
          items: [
            {
              id: 1,
              topic: "Hardware Development",
              points: "ARM Assembly, Verilog, iverilog, GTKWave, Sigasi Studio",
            },
            {
              id: 2,
              topic: "Application Development",
              points: "Java, junit, IntelliJ IDEA, C, C++, CLion",
            },
            {
              id: 3,
              topic: "Data Science",
              points:
                "python3, pandas, numpy, matplotlib, seaborn, sklearn, Spyder, PyCharm, Jupyter Notebook, JupyterLab",
            },
            {
              id: 4,
              topic: "Web Development",
              points:
                "mysql, javascript, html5, CSS, nodejs, yarn, UIkit, Vuejs, Express, Axios, MongoDB, WebStorm",
            },
            {
              id: 5,
              topic: "Shell, CI/CD",
              points: "bash, zsh, Travis CI, github-pages",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
h1,
h3 {
  font-family: "overpass", sans-serif;
  font-weight: 600;
  font-style: normal;
}
</style>
